if (!customElements.get('tt-live-board')) {
  customElements.define('tt-live-board', class extends HTMLElement {
    connectedCallback() {
      if(this.timer) return;
      this.labels=JSON.parse(this.querySelector('[data-labels]').textContent);
      this.hasData=false;this.load();this.timer=setInterval(()=>this.load(),15000);
    }
    disconnectedCallback() {clearInterval(this.timer);this.timer=null;this.controller?.abort();}
            weight(value) {return (value/1000000).toFixed(2)+' lb';}
    async load() {
      if(this.busy) return;
      this.busy=true;this.controller=new AbortController();const timeout=setTimeout(()=>this.controller.abort(),10000);
      try {
        const endpoint=this.dataset.endpoint;
        if(!endpoint||!endpoint.startsWith('https://')) throw Error();
        const response=await fetch(endpoint,{cache:'no-store',credentials:'omit',signal:this.controller.signal});
        if(!response.ok) throw Error();
        const data=await response.json();if(!Array.isArray(data.rows)) throw Error();
        const tbody=this.querySelector('tbody');tbody.replaceChildren();
        for(const row of data.rows.slice(0,Number(this.dataset.limit)||10)) {
          const tr=document.createElement('tr');
          for(const [i,value] of [row.complete?row.position:'—',row.name,this.weight(row.weights[0]),row.weights[1]?this.weight(row.weights[1]):'—',this.weight(row.total)].entries()) {
            const td=document.createElement('td');td.textContent=value;
            if(i===1){const sub=document.createElement('small');sub.textContent=this.labels.entry+' '+row.entry;td.append(sub);}
            if(i===4){td.className='tt-lb-total';if(!row.complete){const sub=document.createElement('small');sub.textContent=this.labels.provisional;td.append(sub);}}
            tr.append(td);
          }
          tbody.append(tr);
        }
        this.querySelector('[data-message]').textContent=data.rows.length?'':this.labels.empty;
        this.querySelector('[data-status]').textContent=this.labels[data.status]||this.labels.live;
        this.querySelector('[data-updated]').textContent=data.updatedAt?this.labels.updated+' '+new Date(data.updatedAt).toLocaleString('en-US',{timeZone:'America/New_York',month:'short',day:'numeric',hour:'numeric',minute:'2-digit'})+' ET':this.labels.none;
        this.hasData=true;
      } catch {
        if(this.isConnected){this.querySelector('[data-message]').textContent=this.hasData?this.labels.stale:this.labels.unavailable;this.querySelector('[data-status]').textContent=this.labels.unavailable;}
      } finally {clearTimeout(timeout);this.busy=false;}
    }
  });
}

if (!customElements.get('tt-calcutta-board')) {
  customElements.define('tt-calcutta-board', class extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.load();
      this.timer = setInterval(() => this.load(), 15000);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.timer = null;
      this.controller?.abort();
    }
    async load() {
      if (this.busy) return;
      this.busy = true;
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 10000);
      try {
        const response = await fetch(this.dataset.endpoint, {cache:'no-store',credentials:'omit',signal:this.controller.signal});
        if (!response.ok) throw Error();
        const data = await response.json();
        if (!Array.isArray(data.rows)) throw Error();
        const tbody = this.querySelector('tbody');
        tbody.replaceChildren();
        for (const row of data.rows) {
          const tr = document.createElement('tr');
          const values = [row.position,row.name,...row.weights.map(weight => (weight / 1000000).toFixed(2) + ' lb'),(row.total / 1000000).toFixed(2) + ' lb'];
          values.forEach((value, index) => {
            const td = document.createElement('td');
            td.textContent = value;
            if (index === 1) {
              const sub = document.createElement('small');
              sub.textContent = 'Entry # ' + row.entry;
              td.append(sub);
            }
            if (index === 5) {
              td.className = 'tt-lb-total';
              if (row.tieReview) {
                const sub = document.createElement('small');
                sub.textContent = 'Tied total · review pending';
                td.append(sub);
              }
            }
            tr.append(td);
          });
          tbody.append(tr);
        }
        this.querySelector('[data-cal-message]').textContent = data.rows.length ? '' : 'No verified complete sets recorded yet.';
        this.querySelector('[data-cal-status]').textContent = data.status === 'final' ? 'Final standings' : 'Live standings';
        this.querySelector('[data-cal-updated]').textContent = data.updatedAt ? 'Last Calcutta weigh-in: ' + new Date(data.updatedAt).toLocaleString('en-US',{timeZone:'America/New_York',month:'short',day:'numeric',hour:'numeric',minute:'2-digit'}) + ' ET' : '';
        this.hasData = true;
      } catch {
        this.querySelector('[data-cal-status]').textContent = 'Temporarily unavailable';
        this.querySelector('[data-cal-message]').textContent = this.hasData ? 'Showing the last received Calcutta standings. Reconnecting…' : 'Calcutta standings are temporarily unavailable. Please try again shortly.';
      } finally {
        clearTimeout(timeout);
        this.busy = false;
      }
    }
  });
}
(() => {
  const mount = () => {
    const main = document.getElementById('tt-live-board');
    if (!main || document.getElementById('tt-calcutta-board')) return;
    const board = document.createElement('tt-calcutta-board');
    board.id = 'tt-calcutta-board';
    board.style.cssText = 'display:block;margin-top:32px;padding-top:28px;border-top:1px solid #3a493d';
    board.dataset.endpoint = new URL('/api/calcutta',main.dataset.endpoint).href;
    board.innerHTML = '<div class="tt-lb-head"><div><p class="tt-lb-eyebrow">GRAND SLAM STANDINGS</p><h2>Grand Slam Calcutta</h2></div><span class="tt-lb-status" data-cal-status>Loading standings…</span></div><p class="tt-lb-intro">One legal blackfish, one legal porgy (scup) and one legal black sea bass presented together during the same weigh-in visit. Highest combined weight wins.</p><div class="tt-lb-scroll"><table><thead><tr><th scope="col">Rank</th><th scope="col">Angler</th><th scope="col">Blackfish</th><th scope="col">Porgy</th><th scope="col">Sea bass</th><th scope="col">Combined</th></tr></thead><tbody></tbody></table></div><p class="tt-lb-intro" data-cal-message role="status">Loading standings…</p><p class="tt-lb-updated" data-cal-updated></p><p class="tt-lb-note">Verified complete sets only. Fish weights from different visits cannot be combined. Refreshes every 15 seconds.</p>';
    main.append(board);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',mount,{once:true});
  else mount();
})();
